import React from 'react';
import styled from 'styled-components';
import { CloseButton } from '../../button';
import { FileIcon } from '../../../assets';
import { theme } from '../../../theme';
import { BodyText, Heading } from '../../typography';
import { truncate } from './utils';
import { UploadProgressBar } from '../../uploadProgressBar';

export type UploadDocumentCardProps = {
  detail?: string;
  name: string;
  onRemove: () => void;
  percentUploaded?: number;
};

const Card = styled.div`
  align-items: center;
  border: 1px solid ${theme.colors.neutrals.solidGrays[5]};
  border-radius: ${theme.borderRadius.default};
  box-sizing: border-box;
  display: flex;
  //required to correctly render the progress bar
  height: 63px;
  overflow: hidden;
  padding: ${theme.spacings[2].rem} ${theme.spacings[2].rem}
    ${theme.spacings[2].rem} ${theme.spacings[4].rem};
  position: relative;
  width: fit-content;
`;

const File = styled(FileIcon)`
  fill: ${theme.colors.primary.graysGray};
  margin-right: ${theme.spacings[4].rem};
  width: 30px;
`;

const Detail = styled(BodyText)`
  color: ${theme.colors.neutrals.solidGrays[2]};
`;

const CloseButtonContainer = styled.div`
  margin-left: ${theme.spacings[4].rem};
`;

export const UploadDocumentCard: React.FC<UploadDocumentCardProps> = ({
  detail,
  name,
  onRemove,
  percentUploaded,
}) => (
  <Card>
    <File />
    <span>
      <Heading size={6}>{truncate(name)}</Heading>
      {detail && <Detail>{truncate(detail)}</Detail>}
    </span>
    <CloseButtonContainer>
      <CloseButton onClick={onRemove} />
    </CloseButtonContainer>
    {!!percentUploaded && percentUploaded < 100 && (
      <UploadProgressBar progress={percentUploaded} />
    )}
  </Card>
);
